<template>
  <v-app>
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-col>
            <ProfileCard />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import ProfileCard from './components/ProfileCard';

export default {
  name: 'App',

  components: {
    ProfileCard,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
body {
  background-color: gray !important; 
}
</style>
